export const ROOT = '/';
export const MAIN_PAGE_ROUTE = `${ROOT}`;
